'use client';
import React, { FC } from 'react';
import Slider, { Settings } from 'react-slick';
import {
  TypeMarketingCarouselFields,
  TypeLink_internalFields,
  TypeLink_externalFields,
} from '@/core/generated-types';
import { Arrow } from '../Carousel/Arrows';
import { HeaderSize } from '@/components/ui/HeaderText';
import { Entry } from 'contentful';
import { UniversalCta, HeaderText, Image } from '@/components';

const MarketingCarousel: FC<TypeMarketingCarouselFields> = ({
  backgroundColor,
  marketingCarouselSlides = [],
}) => {
  const settings: Settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <Arrow className="!md:top-0 !top-[36%]" direction={'right'} />,
    prevArrow: <Arrow className="!md:top-0 !top-[36%]" direction={'left'} />,
  };

  return (
    <div
      className={`bg-${backgroundColor?.fields?.color} px-5 py-10 md:px-36 md:py-20`}
    >
      <Slider
        {...settings}
        className="slider-variant-marketing-carousel mx-auto max-w-[1300px] md:px-16 md:pb-6"
      >
        {marketingCarouselSlides.map((slide) => {
          return (
            <div key={slide.sys.id}>
              <div className="flex flex-col items-center md:flex-row">
                <div className="order-2 px-4 pb-8 pt-0 text-center md:order-1 md:mt-0 md:w-[40%] md:bg-transparent md:p-0 md:pr-12 md:pt-6 md:text-left">
                  {slide.fields.subTitle && (
                    <div className="mb-2">
                      <span className="text-base font-normal leading-6 text-purple md:text-xl md:leading-8">
                        {slide.fields.subTitle}
                      </span>
                    </div>
                  )}
                  <div className="mb-3">
                    <HeaderText
                      size={HeaderSize.H2}
                      text={slide.fields.title}
                    />
                  </div>
                  <div className="mb-4 px-6 text-base md:w-96 md:px-0">
                    {slide.fields.description}
                  </div>
                  <div className="lg:inline-block">
                    <UniversalCta
                      link={
                        slide.fields.cta as unknown as
                          | Entry<TypeLink_internalFields>
                          | Entry<TypeLink_externalFields>
                      }
                      className=""
                      defaultButtonStyle="Primary"
                    />
                  </div>
                </div>
                <div className="order-1 mb-4 h-full w-full px-6 md:order-2 md:mb-0">
                  <Image
                    alt={slide.fields?.image?.fields?.altText}
                    className="h-full w-full object-cover md:pb-6 md:pl-20"
                    imageData={slide?.fields?.image}
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default React.memo(MarketingCarousel);
